import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import AlertBox from '../../Components/AlertBox';

const Branch = () => {
  const [branches, setBranches] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingBranchId, setEditingBranchId] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [isCurrentBranch, setIsCurrentBranch] = useState(false);


  // Safe JWT decode helper - ADD THIS FUNCTION
  const safeJwtDecode = (token) => {
    if (!token) {
      console.error('❌ No token provided to safeJwtDecode');
      return null;
    }

    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('❌ Error decoding JWT token:', error);
      return null;
    }
  };



  const [formData, setFormData] = useState({
    businessName: '',
    businessEmail: '',
    businessPhone: '',
    EmergencyMobNo: '',
    password: '',
    businessCreatedDate: '',
    weeklyHoliday: ['Sunday'],
    address: '',
    businessLogo: '',
    businessSubscriptionPlan: '' // Store branch's own subscription plan
  });
  const [logoPreview, setLogoPreview] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  // Validation Error State
  const [validationErrors, setValidationErrors] = useState({
    businessName: '',
    businessEmail: '',
    businessPhone: '',
    EmergencyMobNo: ''
  });

  // User Limit States
  const [userLimitInfo, setUserLimitInfo] = useState({
    companyUserLimit: 0,
    totalEmployees: 0,
    usedUserLimit: 0,
    employeesInOtherBranches: 0,
    availableForNewBranch: 0,
    remainingUserLimit: 0,
    branchUserLimit: '',
    moduleRemaining: {
      taskManagement: 0,
      leadManagement: 0,
      hrms: 0,
      support: 0,
      projectManagement: 0
    },
    moduleMasterTotal: {
      taskManagement: 0,
      leadManagement: 0,
      hrms: 0,
      support: 0,
      projectManagement: 0
    }
  });

  // Permission mapping for module limits (Synced with AddEmployee.js)
  const permissionModuleMapping = {
    // HRMS Module
    'create_teammember': 'hrms', 'update_teammember': 'hrms', 'delete_teammember': 'hrms',
    'list_teammember': 'hrms', 'employee_report': 'hrms', 'daily_attendace': 'hrms',
    'attendance_report': 'hrms', 'settings_shift': 'hrms', 'leave_request': 'hrms',
    'leave_approval': 'hrms', 'leave_type': 'hrms', 'leave_report': 'hrms',
    'salary_generation': 'hrms', 'create_department': 'hrms', 'update_department': 'hrms',
    'update_leave': 'hrms',

    // Support Module
    'customer_support': 'support', 'com_tickets': 'support',
    'sup_tickets': 'support', 'employee_performance': 'support',

    // Task Management Module
    'list_task': 'taskManagement', 'create_task': 'taskManagement',
    'update_task': 'taskManagement', 'delete_task': 'taskManagement',
    'shifted_task_history': 'taskManagement', 'shift_task': 'taskManagement',
    'credit_points': 'taskManagement', 'create_credit_points': 'taskManagement',
    'task_performance': 'taskManagement',

    // Lead Management Module
    'lead_management': 'leadManagement', 'add_leads': 'leadManagement',
    'link_generator': 'leadManagement', 'edit_lead': 'leadManagement',
    'assign_lead': 'leadManagement',

    // Project Management Module
    'project_dashboard': 'projectManagement', 'projects': 'projectManagement',
    'project_employee_lists': 'projectManagement', 'project_tracker': 'projectManagement',
    'project_tasks': 'projectManagement', 'project_reports': 'projectManagement'
  };
  const [loadingUserLimit, setLoadingUserLimit] = useState(false);

  // Company Plan and Branch Access Permissions States
  const [companyPlan, setCompanyPlan] = useState(null);
  const [branchAccessPermissions, setBranchAccessPermissions] = useState({
    taskManagement: false,
    leadManagement: false,
    hrms: false,
    support: false,
    projectManagement: false
  });
  const [moduleUserLimits, setModuleUserLimits] = useState({
    taskManagement: '',
    leadManagement: '',
    hrms: '',
    support: '',
    projectManagement: ''
  });
  const [originalBranchUserLimit, setOriginalBranchUserLimit] = useState(0); // Store original limit when editing

  // Enhanced token validation
  const validateToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      return null;
    }

    try {
      const decoded = jwtDecode(token);

      console.log(' Token decoded successfully:', {
        role: decoded?.role,
        companyId: decoded?.companyId,
        company: decoded?.company,
        orgId: decoded?.orgId,
        id: decoded?.id,
        exp: decoded?.exp ? new Date(decoded.exp * 1000).toISOString() : 'N/A'
      });

      return token;
    } catch (error) {
      console.error('❌ Token decoding error (non-fatal):', error);
      // We do not clear the token on client-side decoding failures.
      // The API server will validate the token on request and return 401 if it's invalid.
      return token;
    }
  };

  // Enhanced company ID extraction
  const getCurrentCompanyId = (decoded) => {
    if (!decoded) {
      console.log('❌ No decoded token provided');
      return null;
    }

    // Try all possible fields for company ID
    const companyId = decoded.companyId ||
      decoded.company?._id ||
      decoded.orgId ||
      decoded.id ||
      decoded.userId || // Sometimes userId is used
      localStorage.getItem('selectedCompanyId');

    console.log('Company ID extraction attempt:', {
      companyId,
      availableFields: {
        companyId: decoded.companyId,
        company: decoded.company,
        orgId: decoded.orgId,
        id: decoded.id,
        userId: decoded.userId
      },
      fromLocalStorage: localStorage.getItem('selectedCompanyId')
    });

    return companyId;
  };

  // Fetch user limit info when form opens
  useEffect(() => {
    if (showForm && !isEditing) {
      const token = validateToken();
      if (token) {
        const decoded = jwtDecode(token);
        const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || localStorage.getItem('selectedCompanyId');
        if (companyId) {
          fetchUserLimitInfo(companyId);
        }
      }
    }
  }, [showForm]);

  useEffect(() => {
    const initData = async () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        try {
          const decoded = safeJwtDecode(token); // Use safe decode
          if (!decoded) {
            setError('Invalid token. Please log in again.');
            setLoading(false);
            return;
          }

          setUserRole(decoded.role);
          console.log("🚀 Initializing branch component for role:", decoded.role, decoded);

          setLoading(true);
          setError(null); // Clear any previous errors

          // Check if we have necessary company info
          const companyId = getCurrentCompanyId(decoded);
          console.log("Initial company ID check:", companyId);

          if (decoded.role === 'superadmin') {
            const allCompanies = await fetchAllCompanies();
            setCompanies(allCompanies);
            console.log('✅ Superadmin: Fetched', allCompanies.length, 'companies for dropdown');
          } else if (!companyId) {
            console.warn('⚠️ No company ID found for regular user');
            setError('Company information missing. Please log out and log in again.');
            setLoading(false);
            return;
          }

          await fetchBranches();
        } catch (error) {
          console.error('❌ Error initializing branch component:', error);
          setError('Failed to initialize. Please refresh the page or log in again.');
          setLoading(false);
        }
      } else {
        setError('No access token found. Please log in.');
        setLoading(false);
      }
    };

    initData();
  }, []);

  const fetchAllCompanies = async () => {
    const token = validateToken();
    if (!token) return [];

    try {
      const response = await axios.get('https://slateblue-mallard-430836.hostingersite.com/api/companies', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data || [];
    } catch (err) {
      console.error('Error fetching all companies:', err);
      return [];
    }
  };

  const fetchBranches = async () => {
    const token = validateToken();
    if (!token) {
      console.log('­ï Skipping fetchBranches: no valid token');
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(token); // This line is safe now
      const userRole = decoded.role;
      let allBranches = [];

      console.log('Starting fetchBranches for role:', userRole, 'decoded:', decoded);

      if (userRole === 'superadmin') {
        // Superadmin logic (keep your existing superadmin code)
        console.log('Superadmin: Fetching all branches...');
        try {
          const response = await axios.get('https://slateblue-mallard-430836.hostingersite.com/api/branches', {
            headers: { Authorization: `Bearer ${token}` },
            validateStatus: (status) => status < 500
          });

          if (response.status === 200) {
            allBranches = Array.isArray(response.data) ? response.data : (response.data.branches || []);
          } else {
            // Fallback to aggregation
            console.log('¡ Global endpoint not available, aggregating from companies...');
            const allCompanies = await fetchAllCompanies();
            setCompanies(allCompanies);
            for (const company of allCompanies) {
              const companyId = company._id;
              if (companyId) {
                try {
                  const companyResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`, {
                    headers: { Authorization: `Bearer ${token}` },
                    validateStatus: (status) => status < 500
                  });
                  const companyBranches = Array.isArray(companyResponse.data) ? companyResponse.data : (companyResponse.data.branches || []);
                  companyBranches.forEach(branch => {
                    branch.parentCompanyName = company.businessName;
                  });
                  allBranches = [...allBranches, ...companyBranches];
                } catch (companyErr) {
                  console.error(`Error fetching branches for company ${companyId}:`, companyErr);
                }
              }
            }
          }
        } catch (globalErr) {
          console.error('Error in global fetch:', globalErr);
        }
        setBranches(allBranches);
        console.log(`✅ Superadmin loaded ${allBranches.length} total branches from all companies.`);
      } else {
        // Regular user - Enhanced with better error handling
        console.log('Regular user: Fetching branches...');

        const companyId = getCurrentCompanyId(decoded);
        console.log('Final companyId for API call:', companyId);

        if (!companyId) {
          console.error('❌ No company ID found in token or localStorage');
          setError('Company information not found in your session. Please log out and log in again.');
          setLoading(false);
          return;
        }

        // Rest of your regular user logic...
        // First, verify the company exists and get its details
        try {
          console.log('Verifying company existence...');
          const companyResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`, {
            headers: { Authorization: `Bearer ${token}` },
            validateStatus: (status) => status < 500
          });

          if (companyResponse.status === 200) {
            const currentCompany = companyResponse.data;
            const isBranchUser = currentCompany.isBranch || currentCompany.parentCompanyId;

            console.log('Current company verified:', {
              name: currentCompany.businessName,
              isBranch: isBranchUser,
              parentCompanyId: currentCompany.parentCompanyId
            });

            setIsCurrentBranch(isBranchUser);

            // If it's a branch user, handle differently
            if (isBranchUser) {
              console.log('🔒 Branch user - fetching only own branch data');
              allBranches = [currentCompany];
            } else {
              // Regular company user - fetch branches
              console.log('Company user - fetching branches...');
              const branchesResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`, {
                headers: { Authorization: `Bearer ${token}` },
                validateStatus: (status) => status < 500
              });

              console.log('¥ Branches API response status:', branchesResponse.status);

              if (branchesResponse.status === 401) {
                throw new Error('Session expired');
              }

              const branchData = branchesResponse.data;

              // Handle different response formats
              if (Array.isArray(branchData)) {
                allBranches = branchData;
              } else if (branchData && Array.isArray(branchData.branches)) {
                allBranches = branchData.branches;
              } else if (branchData && Array.isArray(branchData.data)) {
                allBranches = branchData.data;
              } else {
                allBranches = [];
                console.log('⚠️ No branches array found in response, using empty array');
              }

              // Filter branches by parentCompanyId
              allBranches = allBranches.filter(branch =>
                branch.parentCompanyId === companyId || branch.parentCompanyId?._id === companyId
              );
            }
          } else {
            console.error('❌ Company verification failed:', companyResponse.status);
            setError('Company not found. Please contact administrator.');
          }
        } catch (verifyError) {
          console.error('❌ Error verifying company:', verifyError);
          if (verifyError.response?.status === 404) {
            setError('Company not found. Please contact administrator.');
          } else if (verifyError.response?.status === 401) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userData');
            localStorage.removeItem('userRole');
            setError('Session expired. Please log in again.');
          } else {
            setError(`Unable to verify company: ${verifyError.message}`);
          }
          setLoading(false);
          return;
        }

        setBranches(allBranches);
        console.log(`✅ Loaded ${allBranches.length} branches for ${isCurrentBranch ? 'branch' : 'company'} user.`);
      }
    } catch (err) {
      console.error("❌ Critical error in fetchBranches:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setError('Session expired. Please log in again.');
      } else if (err.message?.includes('Session expired')) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setError('Session expired. Please log in again.');
      } else {
        setError(`Failed to load branches: ${err.message || 'Please try again later.'}`);
      }
      setBranches([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch company subscription plan and calculate user limit info
  const fetchUserLimitInfo = async (companyId, editingBranchId = null) => {
    const token = validateToken();
    if (!token) return;

    setLoadingUserLimit(true);
    try {
      // 1. Fetch company details to get subscription plan
      const companyResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const company = companyResponse.data;
      let businessSubscriptionPlan = company.businessSubscriptionPlan;
      const companyAssignedLimit = parseInt(company.userLimit) || 0;

      // 2. Fetch latest subscription plan if possible
      let planDetails = null;
      if (businessSubscriptionPlan) {
        let planId = null;
        if (typeof businessSubscriptionPlan === 'string') {
          try {
            const parsed = JSON.parse(businessSubscriptionPlan.replace(/\\"/g, '"'));
            planDetails = parsed;
            planId = parsed._id || parsed.id;
          } catch (e) {
            if (/^[0-9a-fA-F]{24}$/.test(businessSubscriptionPlan)) planId = businessSubscriptionPlan;
          }
        } else if (typeof businessSubscriptionPlan === 'object') {
          planDetails = businessSubscriptionPlan;
          planId = planDetails._id || planDetails.id;
        }

        if (planId && /^[0-9a-fA-F]{24}$/.test(planId)) {
          try {
            const planResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/subscription-plans/${planId}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (planResponse.data && planResponse.data.plan) {
              planDetails = planResponse.data.plan;
            }
          } catch (fetchErr) {
            console.warn('⚠️ Failed to fetch latest plan details:', fetchErr.message);
          }
        }
      }

      // 3. Calculate Master Totals
      let masterTotal = companyAssignedLimit || (planDetails ? parseInt(planDetails.userLimit) : 0) || 0;
      const moduleMasterTotal = {
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      };

      if (planDetails) {
        setCompanyPlan(planDetails);
        const limits = planDetails.userLimits || {};
        Object.keys(moduleMasterTotal).forEach(key => {
          moduleMasterTotal[key] = parseInt(limits[key]) || masterTotal; // Default to masterTotal if not set
        });
        // If masterTotal is 0, derive it from max module limit
        if (masterTotal === 0) {
          const vals = Object.values(moduleMasterTotal).filter(v => v > 0);
          if (vals.length > 0) masterTotal = Math.max(...vals);
        }
      }

      // 4. Fetch Employees to get Main Company usage
      let mainCompanyUsed = 0;
      const moduleUsedByMain = {
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      };

      try {
        const employeesResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${companyId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const employees = employeesResponse.data || [];

        // Only count employees directly in the Main Company
        const directEmployees = employees.filter(emp => {
          const empCompanyId = emp.company?._id || emp.company;
          // Ensure string comparison
          return empCompanyId?.toString() === companyId?.toString();
        });

        mainCompanyUsed = directEmployees.length;

        directEmployees.forEach(emp => {
          // Skip inactive employees
          if (emp.isActive === false) return;

          const perms = emp.accessPermissions || [];
          if (Array.isArray(perms)) {
            const usedModules = new Set();
            perms.forEach(permission => {
              const module = permissionModuleMapping[permission];
              if (module) usedModules.add(module);
            });

            usedModules.forEach(module => {
              if (moduleUsedByMain[module] !== undefined) {
                moduleUsedByMain[module]++;
              }
            });
          }
        });
        console.log('Main Company Module Usage:', moduleUsedByMain);
      } catch (empErr) {
        console.error('Error fetching employees for pool calculation:', empErr);
      }

      // 5. Fetch other branches to get allocations
      const moduleAllocatedToOtherBranches = {
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      };
      let totalAllocatedOtherBranches = 0;

      try {
        const branchesResponse = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // FIX: The backend returns { branches: [...] }
        const branches = branchesResponse.data.branches || branchesResponse.data || [];

        if (Array.isArray(branches)) {
          branches.forEach(branch => {
            // Skip current branch being edited
            if (editingBranchId && (branch._id === editingBranchId || branch._id?.toString() === editingBranchId.toString())) return;

            let branchPlan = branch.businessSubscriptionPlan;
            if (typeof branchPlan === 'string') {
              try {
                branchPlan = JSON.parse(branchPlan.replace(/\\"/g, '"'));
              } catch (e) { /* ignore */ }
            }

            const data = branchPlan?.plan || branchPlan || {};
            const limits = data.userLimits || data.moduleUserLimits || {};

            // Get the total user limit for this branch
            // 1. Try from JSON plan object
            // 2. Try from branch.userLimit (direct field)
            // 3. Fallback to derived max from module limits
            let branchTotal = parseInt(data.userLimit) || parseInt(branch.userLimit) || 0;

            if (branchTotal === 0 && limits && typeof limits === 'object') {
              const vals = Object.values(limits).map(v => parseInt(v)).filter(v => !isNaN(v));
              if (vals.length > 0) branchTotal = Math.max(...vals);
            }

            totalAllocatedOtherBranches += branchTotal;
            Object.keys(moduleAllocatedToOtherBranches).forEach(key => {
              moduleAllocatedToOtherBranches[key] += parseInt(limits[key]) || 0;
            });
          });
        }
        console.log('Other Branches Module Allocations:', moduleAllocatedToOtherBranches);
      } catch (branchErr) {
        console.error('Error fetching branches for pool calculation:', branchErr);
      }

      // 6. Calculate Remaining Pool
      const moduleRemaining = {};
      Object.keys(moduleMasterTotal).forEach(key => {
        moduleRemaining[key] = moduleMasterTotal[key] - moduleUsedByMain[key] - moduleAllocatedToOtherBranches[key];
      });

      // The global "Available for new branch" is based on the masterTotal minus already occupied seats
      const availableForNewBranch = masterTotal - mainCompanyUsed - totalAllocatedOtherBranches;

      console.log('📈 Final Pool Calculation:', {
        masterTotal,
        mainCompanyUsed,
        totalAllocatedOtherBranches,
        availableForNewBranch,
        moduleRemaining
      });

      setUserLimitInfo({
        companyUserLimit: masterTotal,
        totalEmployees: mainCompanyUsed,
        usedUserLimit: mainCompanyUsed,
        employeesInOtherBranches: totalAllocatedOtherBranches,
        availableForNewBranch,
        remainingUserLimit: Math.max(0, availableForNewBranch),
        branchUserLimit: '',
        moduleRemaining,
        moduleMasterTotal
      });

    } catch (error) {
      console.error('❌ Error in fetchUserLimitInfo:', error);
    } finally {
      setLoadingUserLimit(false);
    }
  };


  // Add this useEffect to recalculate when editing starts
  useEffect(() => {
    if (isEditing && editingBranchId) {
      const token = validateToken();
      if (token) {
        const decoded = jwtDecode(token);
        const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || localStorage.getItem('selectedCompanyId');
        if (companyId) {
          console.log('„ Recalculating user limits for editing...');
          fetchUserLimitInfo(companyId);
        }
      }
    }
  }, [isEditing, editingBranchId]);


  const validateBusinessName = (value) => {
    const cleanValue = value; // Don't trim - allow spaces while typing

    if (cleanValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    if (cleanValue.length < 2) {
      return { isValid: false, message: 'Business name should be at least 2 characters long', cleanValue: cleanValue };
    }

    if (cleanValue.length > 100) {
      return { isValid: false, message: 'Business name should not exceed 100 characters', cleanValue: cleanValue.substring(0, 100) };
    }

    return { isValid: true, message: '', cleanValue: cleanValue };
  };

  const validateBusinessEmail = (value) => {
    const cleanValue = value.toLowerCase().trim();

    if (cleanValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(cleanValue)) {
      return { isValid: false, message: 'Please enter a valid email address', cleanValue: cleanValue };
    }

    if (cleanValue.length > 254) {
      return { isValid: false, message: 'Email address is too long', cleanValue: cleanValue.substring(0, 254) };
    }

    return { isValid: true, message: '', cleanValue: cleanValue };
  };

  const validatePhoneNumber = (value) => {
    const numericValue = value.replace(/[^0-9+\-]/g, '');

    if (numericValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    const phoneRegex = /^[+]?[0-9\-]{10,15}$/;
    if (!phoneRegex.test(numericValue)) {
      return { isValid: false, message: 'Please enter a valid phone number (10-15 digits)', cleanValue: numericValue };
    }

    const digitsOnly = numericValue.replace(/[^0-9]/g, '');
    if (digitsOnly.length < 10) {
      return { isValid: false, message: 'Phone number should have at least 10 digits', cleanValue: numericValue };
    }

    if (digitsOnly.length > 15) {
      return { isValid: false, message: 'Phone number should not exceed 15 digits', cleanValue: numericValue.substring(0, 15) };
    }

    return { isValid: true, message: '', cleanValue: numericValue };
  };

  // Helper function to extract user limit from subscription plan JSON
  const extractUserLimitFromPlan = (planData) => {
    try {
      if (!planData) return 0;

      let plan = planData;

      // If it's a string, parse it
      if (typeof plan === 'string') {
        plan = JSON.parse(plan.replace(/\\"/g, '"'));
      }

      // Return user limit if found
      return plan?.userLimit ? parseInt(plan.userLimit) : 0;
    } catch (error) {
      console.error('Error extracting user limit from plan:', error);
      return 0;
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = value;
    let newErrors = { ...validationErrors };

    if (name === 'businessName') {
      const validation = validateBusinessName(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'businessEmail') {
      const validation = validateBusinessEmail(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'businessPhone' || name === 'EmergencyMobNo') {
      const validation = validatePhoneNumber(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    }

    setValidationErrors(newErrors);

    if (name === 'weeklyHoliday') {
      if (checked) {
        setFormData(prev => ({
          ...prev,
          weeklyHoliday: [...prev.weeklyHoliday, value]
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          weeklyHoliday: prev.weeklyHoliday.filter(day => day !== value)
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : processedValue
      }));
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setShowAlert('❌ Please select a valid image file (JPG, PNG, etc.).');
        e.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setShowAlert('❌ File size must be less than 5MB.');
        e.target.value = '';
        return;
      }
      setLogoFile(file);
      const previewUrl = URL.createObjectURL(file);
      setLogoPreview(previewUrl);
      setFormData(prev => ({ ...prev, businessLogo: '' }));
    } else {
      setLogoFile(null);
      setLogoPreview(null);
      setFormData(prev => ({ ...prev, businessLogo: '' }));
    }
  };



  // Check if the current user is in a branch (not a parent company)
  useEffect(() => {
    const checkIfBranch = async () => {
      const token = validateToken();
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const companyId = getCurrentCompanyId(decoded);

        if (!companyId) return;

        const response = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: (status) => status < 500
        });

        if (response.status === 200) {
          const company = response.data;
          const isBranch = !!company.parentCompanyId;
          setIsCurrentBranch(isBranch);
        }
      } catch (error) {
        console.error('❌ Error checking if current company is a branch:', error);
      }
    };

    checkIfBranch();
  }, []);


  const handleAddBranch = async (e) => {
    e.preventDefault();

    const token = validateToken();
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    const hasValidationErrors = Object.values(validationErrors).some(error => error !== '');
    if (hasValidationErrors) {
      setShowAlert('❌ Please fix the validation errors before submitting');
      return;
    }

    if (!formData.businessName.trim()) {
      setShowAlert('❌ Business name is required');
      return;
    }

    if (!formData.businessEmail.trim()) {
      setShowAlert('❌ Business email is required');
      return;
    }

    // Calculate effective branch user limit - it should be the MAXIMUM of module limits, not the sum
    // Because the same employees can have access to multiple modules.
    const moduleLimits = Object.values(moduleUserLimits).map(v => parseInt(v) || 0);
    const effectiveUserLimit = moduleLimits.length > 0 ? Math.max(...moduleLimits) : 0;

    // Validation
    if (userLimitInfo.companyUserLimit > 0) {
      // 1. Module Specific Limits Check
      for (const key of Object.keys(moduleUserLimits)) {
        if (branchAccessPermissions[key]) {
          const limit = parseInt(moduleUserLimits[key]) || 0;
          const remaining = userLimitInfo.moduleRemaining[key];

          if (limit > remaining) {
            const moduleLabel = {
              taskManagement: 'Task Management',
              leadManagement: 'Lead Management',
              hrms: 'HRMS',
              support: 'Support',
              projectManagement: 'Project Management'
            }[key];
            setShowAlert(`❌ ${moduleLabel} limit of ${limit} exceeds available module pool of ${remaining}`);
            return;
          }
        }
      }
    }

    try {
      const decoded = jwtDecode(token);
      let companyId = decoded.companyId || decoded.company?._id || decoded.orgId || localStorage.getItem('selectedCompanyId');

      if (userRole === 'superadmin' && !companyId) {
        setShowAlert('Please select a parent company to add the branch to.');
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append('businessName', formData.businessName.trim());
      formDataToSend.append('businessEmail', formData.businessEmail.toLowerCase().trim());
      formDataToSend.append('businessPhone', formData.businessPhone.trim());
      formDataToSend.append('EmergencyMobNo', formData.EmergencyMobNo.trim());
      formDataToSend.append('password', formData.password);
      formDataToSend.append('businessCreatedDate', formData.businessCreatedDate || new Date().toISOString());
      formDataToSend.append('weeklyHoliday', JSON.stringify(formData.weeklyHoliday));
      formDataToSend.append('address', formData.address.trim());
      formDataToSend.append('isBranch', 'true');
      formDataToSend.append('parentCompanyId', companyId);

      // Create branch subscription plan in the exact JSON format requested (Same as company)
      const branchPlan = {
        title: "Branch Plan",
        price: "0",
        userLimits: {
          taskManagement: parseInt(moduleUserLimits.taskManagement) || 0,
          leadManagement: parseInt(moduleUserLimits.leadManagement) || 0,
          hrms: parseInt(moduleUserLimits.hrms) || 0,
          support: parseInt(moduleUserLimits.support) || 0,
          projectManagement: parseInt(moduleUserLimits.projectManagement) || 0
        },
        accessPermissions: {
          taskManagement: !!branchAccessPermissions.taskManagement,
          leadManagement: !!branchAccessPermissions.leadManagement,
          hrms: !!branchAccessPermissions.hrms,
          support: !!branchAccessPermissions.support,
          projectManagement: !!branchAccessPermissions.projectManagement
        },
        startDate: companyPlan?.startDate || new Date().toISOString(),
        endDate: companyPlan?.endDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
      };
      formDataToSend.append('businessSubscriptionPlan', JSON.stringify(branchPlan));
      formDataToSend.append('userLimit', effectiveUserLimit); // Send as separate field for backend logic

      if (logoFile) {
        formDataToSend.append('businessLogo', logoFile);
      }

      const response = await axios.post(
        `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          validateStatus: (status) => status < 500
        }
      );

      if (response.status >= 400) {
        setShowAlert(`❌ Error creating branch: ${response.data.message || 'Please try again.'}`);
        return;
      }

      fetchBranches();
      resetForm();
      setShowSuccessAlert('Branch created successfully!');
    } catch (error) {
      console.error("Error creating branch:", error);
      setShowAlert(`❌ Error creating branch: ${error.response?.data?.message || 'Please try again.'}`);
    }
  };

  const handleEditBranch = async (branch) => {
    setIsEditing(true);
    setEditingBranchId(branch._id);
    setLoadingEditData(true);

    let permissions = {
      taskManagement: false,
      leadManagement: false,
      hrms: false,
      support: false,
      projectManagement: false
    };
    let limits = {
      taskManagement: '',
      leadManagement: '',
      hrms: '',
      support: '',
      projectManagement: ''
    };
    let branchUserLimit = '';

    if (branch.businessSubscriptionPlan) {
      let planData = branch.businessSubscriptionPlan;
      if (typeof planData === 'string') {
        try {
          planData = JSON.parse(planData.replace(/\\"/g, '"'));
        } catch (e) { }
      }

      if (typeof planData === 'object') {
        permissions = { ...permissions, ...planData.accessPermissions };
        // Support both naming conventions: userLimits (new) and moduleUserLimits (old)
        const storedLimits = planData.userLimits || planData.moduleUserLimits || {};
        limits = { ...limits, ...storedLimits };
        branchUserLimit = (planData.userLimit || '').toString();
      }
    }

    if (!branchUserLimit && branch.assignedUserLimit) {
      branchUserLimit = branch.assignedUserLimit.toString();
    }

    setBranchAccessPermissions(permissions);
    setModuleUserLimits(limits);
    setOriginalBranchUserLimit(parseInt(branchUserLimit) || 0);

    setFormData({
      businessName: branch.businessName || '',
      businessEmail: branch.businessEmail || '',
      businessPhone: branch.businessPhone || '',
      EmergencyMobNo: branch.EmergencyMobNo || '',
      password: '',
      businessCreatedDate: branch.businessCreatedDate ? branch.businessCreatedDate.split('T')[0] : '',
      weeklyHoliday: branch.weeklyHoliday || ['Sunday'],
      address: branch.address || '',
      businessLogo: branch.businessLogo || '',
      businessSubscriptionPlan: branch.businessSubscriptionPlan || ''
    });
    setLogoPreview(branch.businessLogo || null);

    const token = validateToken();
    if (token) {
      const decoded = jwtDecode(token);
      const companyId = getCurrentCompanyId(decoded);
      if (companyId) await fetchUserLimitInfo(companyId, branch._id);
    }

    setShowForm(true);
    setLoadingEditData(false);
  };

  const [loadingEditData, setLoadingEditData] = useState(false);

  const handleUpdateBranch = async (e) => {
    e.preventDefault();

    const token = validateToken();
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    // Calculate effective branch user limit - it should be the MAXIMUM of module limits, not the sum
    const moduleLimits = Object.values(moduleUserLimits).map(v => parseInt(v) || 0);
    const effectiveUserLimit = moduleLimits.length > 0 ? Math.max(...moduleLimits) : 0;

    // Validation
    if (userLimitInfo.companyUserLimit > 0) {
      // 1. Module Specific Limits Check
      for (const key of Object.keys(moduleUserLimits)) {
        if (branchAccessPermissions[key]) {
          const limit = parseInt(moduleUserLimits[key]) || 0;

          const remaining = userLimitInfo.moduleRemaining[key];

          if (limit > remaining) {
            const moduleLabel = {
              taskManagement: 'Task Management',
              leadManagement: 'Lead Management',
              hrms: 'HRMS',
              support: 'Support',
              projectManagement: 'Project Management'
            }[key];
            setShowAlert(`❌ ${moduleLabel} limit of ${limit} exceeds available module pool of ${remaining}`);
            return;
          }
        }
      }
    }

    try {
      const decoded = jwtDecode(token);
      const companyId = getCurrentCompanyId(decoded);

      const formDataToSend = new FormData();
      formDataToSend.append('businessName', formData.businessName.trim());
      formDataToSend.append('businessEmail', formData.businessEmail.toLowerCase().trim());
      formDataToSend.append('businessPhone', formData.businessPhone.trim());
      formDataToSend.append('EmergencyMobNo', formData.EmergencyMobNo.trim());
      formDataToSend.append('businessCreatedDate', formData.businessCreatedDate || new Date().toISOString());
      formDataToSend.append('weeklyHoliday', JSON.stringify(formData.weeklyHoliday));
      formDataToSend.append('address', formData.address.trim());
      formDataToSend.append('isBranch', 'true');
      formDataToSend.append('parentCompanyId', companyId);

      // Update branch subscription plan in the exact JSON format requested (Same as company)
      const branchPlan = {
        title: "Branch Plan",
        price: "0",
        userLimits: {
          taskManagement: parseInt(moduleUserLimits.taskManagement) || 0,
          leadManagement: parseInt(moduleUserLimits.leadManagement) || 0,
          hrms: parseInt(moduleUserLimits.hrms) || 0,
          support: parseInt(moduleUserLimits.support) || 0,
          projectManagement: parseInt(moduleUserLimits.projectManagement) || 0
        },
        accessPermissions: {
          taskManagement: !!branchAccessPermissions.taskManagement,
          leadManagement: !!branchAccessPermissions.leadManagement,
          hrms: !!branchAccessPermissions.hrms,
          support: !!branchAccessPermissions.support,
          projectManagement: !!branchAccessPermissions.projectManagement
        },
        startDate: companyPlan?.startDate || new Date().toISOString(),
        endDate: companyPlan?.endDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
      };

      formDataToSend.append('businessSubscriptionPlan', JSON.stringify(branchPlan));
      formDataToSend.append('userLimit', effectiveUserLimit); // Send as separate field for backend logic

      if (logoFile) formDataToSend.append('businessLogo', logoFile);
      else if (formData.businessLogo) formDataToSend.append('businessLogo', formData.businessLogo);

      const response = await axios.put(
        `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches/${editingBranchId}`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          validateStatus: (status) => status < 500
        }
      );

      if (response.status >= 400) {
        setShowAlert(`❌ Error updating branch: ${response.data.message || 'Please try again.'}`);
        return;
      }

      fetchBranches();
      resetForm();
      setShowSuccessAlert('Branch updated successfully!');
    } catch (error) {
      console.error("Error updating branch:", error);
      setShowAlert(`❌ Error updating branch: ${error.response?.data?.message || 'Please try again.'}`);
    }
  };

  const handleDeleteBranch = (branchId, branchName) => {
    setConfirmAction({
      type: 'delete',
      message: `Are you sure you want to delete the branch "${branchName}"?`,
      branchId: branchId
    });
  };

  const handleConfirmAction = async () => {
    const token = validateToken();
    if (!token) return;

    try {
      setSubmitting(true);
      if (confirmAction.type === 'delete') {
        const decoded = jwtDecode(token);
        const companyId = getCurrentCompanyId(decoded);
        await axios.delete(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches/${confirmAction.branchId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setShowSuccessAlert('Branch deleted successfully!');
        fetchBranches();
      }
    } catch (error) {
      console.error("Error:", error);
      setShowAlert('Operation failed.');
    } finally {
      setSubmitting(false);
      setConfirmAction(null);
    }
  };

  const handleCloseAlert = () => setConfirmAction(null);
  const handleCloseSuccessAlert = () => setShowSuccessAlert(null);
  const handleCloseErrorAlert = () => setShowAlert(null);
  const handleRecovery = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const resetForm = () => {
    setFormData({
      businessName: '', businessEmail: '', businessPhone: '', EmergencyMobNo: '',
      password: '', businessCreatedDate: '', weeklyHoliday: ['Sunday'],
      address: '', businessLogo: '', businessSubscriptionPlan: ''
    });
    setLogoFile(null);
    setLogoPreview(null);
    setShowPassword(false);
    setValidationErrors({ businessName: '', businessEmail: '', businessPhone: '', EmergencyMobNo: '' });
    setUserLimitInfo({
      companyUserLimit: 0, totalEmployees: 0, usedUserLimit: 0,
      employeesInOtherBranches: 0, availableForNewBranch: 0,
      remainingUserLimit: 0, branchUserLimit: ''
    });
    setBranchAccessPermissions({
      taskManagement: false, leadManagement: false, hrms: false,
      support: false, projectManagement: false
    });
    setModuleUserLimits({
      taskManagement: '', leadManagement: '', hrms: '',
      support: '', projectManagement: ''
    });
    setCompanyPlan(null);
    setOriginalBranchUserLimit(0);
    setShowForm(false);
    setIsEditing(false);
    setEditingBranchId(null);
  };

  const handleViewBranch = (branch) => {
    setSelectedBranch(branch);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedBranch(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading branches...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <button onClick={() => window.location.reload()} className="px-4 py-2 bg-blue-600 text-white rounded">Refresh</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4">
      <div className="max-w-full mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-0 flex items-center">
            <span className="md:hidden p-2 mr-3 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl text-white shadow-md">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </span>
            Branch Management
          </h1>
          {userRole !== 'employee' && !isCurrentBranch && (
            <button
              onClick={async () => {
                if (showForm) {
                  resetForm();
                } else {
                  const token = validateToken();
                  if (token) {
                    const decoded = jwtDecode(token);
                    const companyId = getCurrentCompanyId(decoded);
                    if (companyId) await fetchUserLimitInfo(companyId);
                  }
                  setShowForm(true);
                }
              }}
              className="w-full md:w-auto px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl md:rounded-md hover:from-indigo-700 hover:to-purple-700 transition shadow-md flex justify-center items-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 md:hidden" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
              </svg>
              {showForm ? 'Cancel' : 'Add Branch'}
            </button>
          )}
        </div>

        {showForm && (
          <div className="bg-white rounded-xl shadow-md md:shadow-md p-4 md:p-6 mb-6 md:mb-8 border border-slate-100 md:border-transparent animate-slide-down">
            <h2 className="text-lg md:text-xl font-semibold text-slate-800 mb-4 md:mb-6">{isEditing ? 'Edit Branch' : 'Add New Branch'}</h2>
            <form onSubmit={isEditing ? handleUpdateBranch : handleAddBranch} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Branch Name *</label>
                  <input type="text" name="businessName" value={formData.businessName} onChange={handleInputChange} required className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Branch Email *</label>
                  <input type="email" name="businessEmail" value={formData.businessEmail} onChange={handleInputChange} required className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Branch Phone</label>
                  <input type="text" name="businessPhone" value={formData.businessPhone} onChange={handleInputChange} className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Emergency Mobile No</label>
                  <input type="text" name="EmergencyMobNo" value={formData.EmergencyMobNo} onChange={handleInputChange} className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors" />
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Password {isEditing ? '(Locked)' : '*'}</label>
                  <input type="password" name="password" value={formData.password} onChange={handleInputChange} disabled={isEditing} className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors disabled:bg-slate-50 md:disabled:bg-gray-100" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Branch Created Date</label>
                  <input type="date" name="businessCreatedDate" value={formData.businessCreatedDate} onChange={handleInputChange} readOnly={isEditing} className={`w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors ${isEditing ? 'bg-slate-50 md:bg-gray-100 cursor-not-allowed' : ''}`} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-2">Weekly Holiday</label>
                  <div className="grid grid-cols-2 gap-3 md:gap-2 bg-slate-50 md:bg-transparent p-3 md:p-0 rounded-lg md:rounded-none border border-slate-100 md:border-none">
                    {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => (
                      <label key={day} className="flex items-center space-x-3 md:space-x-2">
                        <input type="checkbox" value={day} checked={formData.weeklyHoliday.includes(day)} onChange={handleInputChange} name="weeklyHoliday" className="w-4 h-4 md:w-auto md:h-auto rounded border-slate-300 md:border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                        <span className="text-sm text-slate-700 md:text-gray-700">{day}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div className="space-y-4 md:space-y-4 pt-2 md:pt-0 border-t border-slate-100 md:border-none">
                {showForm && companyPlan && companyPlan.accessPermissions && (
                  <div className="space-y-5 md:space-y-6 mt-2 md:mt-0">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-2 md:mb-3"> Branch Access Permissions</label>
                      <div className="bg-indigo-50 md:bg-blue-50 border border-indigo-100 md:border-blue-200 rounded-xl md:rounded-md p-3 md:p-4 space-y-3">
                        {[
                          { key: 'taskManagement', label: '📋 Task Management', cleanLabel: 'Task Management' },
                          { key: 'leadManagement', label: '👥 Lead Management', cleanLabel: 'Lead Management' },
                          { key: 'hrms', label: 'HRMS', cleanLabel: 'HRMS' },
                          { key: 'support', label: '†˜ Support', cleanLabel: 'Support' },
                          { key: 'projectManagement', label: '📊 Project Management', cleanLabel: 'Project Management' }
                        ].map(permission => (
                          companyPlan.accessPermissions[permission.key] && (
                            <label key={permission.key} className="flex items-center cursor-pointer p-2 hover:bg-indigo-100 md:hover:bg-blue-100 rounded-lg md:rounded transition-colors">
                              <input
                                type="checkbox"
                                checked={branchAccessPermissions[permission.key]}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setBranchAccessPermissions(prev => ({ ...prev, [permission.key]: checked }));
                                  if (!checked) setModuleUserLimits(prev => ({ ...prev, [permission.key]: '' }));
                                }}
                                className="w-4 h-4 text-indigo-600 border-slate-300 md:border-gray-300 rounded focus:ring-indigo-500"
                              />
                              <span className="ml-3 md:ml-2 text-sm font-medium md:font-normal text-slate-800 md:text-gray-800">
                                <span className="md:hidden">{permission.cleanLabel}</span>
                                <span className="hidden md:inline">{permission.label}</span>
                              </span>
                            </label>
                          )
                        ))}
                      </div>
                    </div>

                    <div>
                      <div className="flex items-center justify-between mb-2 md:mb-3">
                        <label className="block text-sm font-medium text-slate-700 md:text-gray-700">Menu Limit Access</label>
                      </div>
                      <div className="border border-slate-200 md:border-gray-200 rounded-xl md:rounded-lg p-3 md:p-4 bg-white space-y-3 md:space-y-4 shadow-sm md:shadow-sm">
                        {[
                          { key: 'taskManagement', label: 'Task Management' },
                          { key: 'leadManagement', label: 'Lead Management' },
                          { key: 'hrms', label: 'HRMS' },
                          { key: 'support', label: 'Support' },
                          { key: 'projectManagement', label: 'Project Management' }
                        ].map(module => (
                          branchAccessPermissions[module.key] && (
                            <div key={module.key} className="flex flex-col space-y-2.5 md:space-y-2 p-3 border border-slate-100 md:border-gray-100 rounded-lg bg-slate-50 md:bg-gray-50">
                              <div className="flex items-center justify-between">
                                <span className="text-sm font-medium text-slate-700 md:text-gray-700">{module.label}</span>
                                <div className="flex items-center space-x-2">
                                  <span className="text-xs text-slate-500 md:text-gray-500">Limit:</span>
                                  <input
                                    type="number"
                                    value={moduleUserLimits[module.key]}
                                    onChange={(e) => {
                                      const newVal = parseInt(e.target.value) || 0;
                                      const maxAllowed = userLimitInfo.moduleRemaining[module.key];
                                      // Clamp the value between 0 and the max allowed remaining seats
                                      const clampedVal = Math.max(0, Math.min(newVal, maxAllowed));
                                      setModuleUserLimits(prev => ({ ...prev, [module.key]: clampedVal }));
                                    }}
                                    placeholder="0"
                                    className="w-16 md:w-20 px-2 py-1.5 md:py-1 border border-slate-200 md:border-gray-300 rounded-lg md:rounded text-sm font-semibold focus:ring-2 focus:ring-indigo-500 outline-none transition-colors"
                                    min="0"
                                    max={userLimitInfo.moduleRemaining[module.key]}
                                  />
                                </div>
                              </div>
                              <div className="flex justify-end">
                                <span className="text-[10px] font-bold px-2 py-1 md:py-0.5 rounded-full bg-emerald-100 md:bg-green-100 text-emerald-700 md:text-green-600">
                                  Remaining: {userLimitInfo.moduleRemaining[module.key] - (parseInt(moduleUserLimits[module.key]) || 0)}
                                </span>
                              </div>
                            </div>
                          )
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className={showForm && companyPlan && companyPlan.accessPermissions ? 'mt-4 md:mt-0' : ''}>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Address</label>
                  <textarea name="address" value={formData.address} onChange={handleInputChange} rows="3" className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors" placeholder="123 Main St, City, State" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 md:text-gray-700 mb-1.5 md:mb-1">Business Logo</label>
                  <input type="file" accept="image/*" onChange={handleLogoChange} className="w-full px-4 py-2.5 md:py-2 text-sm md:text-base border border-slate-200 md:border-gray-300 rounded-lg md:rounded-md focus:ring-2 focus:ring-indigo-100 md:focus:ring-0 focus:border-indigo-500 md:focus:ring-indigo-500 md:focus:border-indigo-500 outline-none transition-colors file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" />
                  {logoPreview && <img src={logoPreview} alt="Logo" className="mt-3 md:mt-2 w-20 h-20 object-cover rounded-xl md:rounded-md border border-slate-200 md:border-gray-300 shadow-sm" />}
                </div>
              </div>

              <div className="md:col-span-2 lg:col-span-3 pt-2 md:pt-4">
                <button type="submit" className="w-full md:w-auto px-6 py-3.5 md:py-3 bg-gradient-to-r from-emerald-500 to-teal-500 md:from-green-600 md:to-teal-600 text-white font-semibold md:font-normal rounded-xl md:rounded-md hover:from-emerald-600 hover:to-teal-600 md:hover:from-green-700 md:hover:to-teal-700 transition shadow-md flex justify-center items-center text-lg md:text-base">
                  {isEditing ? 'Update Branch' : 'Create Branch'}
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-transparent md:bg-white rounded-none md:rounded-xl shadow-none md:shadow-md overflow-hidden">
          <div className="hidden md:block px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">Branch List</h2>
          </div>
          <div className="md:hidden flex items-center justify-between mb-4 mt-6">
            <h2 className="text-lg font-semibold text-slate-800">Branch List</h2>
            <span className="text-xs font-medium px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full">{branches.length} branches</span>
          </div>

          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">sr no</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Branch Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">User Limit</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {branches.map((branch, index) => (
                  <tr key={branch._id}>
                    <td className="px-6 py-4 text-sm text-gray-900">{index + 1}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{branch.businessName || branch.name}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{branch.businessEmail || branch.email}</td>
                    <td className="px-6 py-4 text-sm">
                      <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full font-semibold text-xs">
                        👥 {branch.userLimit || branch.assignedUserLimit || 'No Limit'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <button onClick={() => handleViewBranch(branch)} className="text-blue-600 mr-3">View</button>
                      <button onClick={() => handleEditBranch(branch)} className="text-indigo-600 mr-3">Edit</button>
                      <button onClick={() => handleDeleteBranch(branch._id, branch.businessName)} className="text-red-600">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden space-y-4">
            {branches.length === 0 ? (
              <div className="p-8 text-center text-gray-500 bg-white rounded-xl shadow-sm">No branches found.</div>
            ) : (
              branches.map((branch, index) => (
                <div key={branch._id} className="relative bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
                  <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-blue-500 to-cyan-500"></div>
                  <div className="p-4 pl-5">
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex items-start flex-1 mr-2">
                        <div className="mt-0.5 mr-2 text-slate-400 font-bold text-sm">#{index + 1}</div>
                        <div>
                          <h3 className="text-base font-semibold text-slate-800 break-words line-clamp-2">{branch.businessName || branch.name}</h3>
                          <div className="mt-1 flex items-center text-sm text-slate-500">
                            <svg className="w-3.5 h-3.5 mr-1.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                            {branch.businessEmail || branch.email}
                          </div>
                        </div>
                      </div>
                      <span className="px-2.5 py-1 bg-blue-50 text-blue-700 rounded-full font-semibold text-xs border border-blue-100 whitespace-nowrap">
                        👥 {branch.userLimit || branch.assignedUserLimit || 'No Limit'}
                      </span>
                    </div>

                    <div className="flex justify-end space-x-2 pt-2 mt-3 border-t border-slate-100">
                      <button
                        onClick={() => handleViewBranch(branch)}
                        className="flex-1 flex justify-center items-center px-3 py-2 bg-slate-50 text-slate-600 rounded-lg text-sm font-medium hover:bg-slate-100 transition-colors"
                      >
                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        View
                      </button>
                      <button
                        onClick={() => handleEditBranch(branch)}
                        className="flex-1 flex justify-center items-center px-3 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors"
                      >
                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteBranch(branch._id, branch.businessName)}
                        className="flex-1 flex justify-center items-center px-3 py-2 bg-rose-50 text-rose-600 rounded-lg text-sm font-medium hover:bg-rose-100 transition-colors"
                      >
                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {showViewModal && selectedBranch && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <h2 className="text-2xl font-bold">Branch Details</h2>
              <button onClick={closeViewModal} className="text-gray-400 hover:text-gray-600">✅•</button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
              <div className="space-y-3">
                <p><strong>Name:</strong> {selectedBranch.businessName}</p>
                <p><strong>Email:</strong> {selectedBranch.businessEmail}</p>
                <p><strong>Phone:</strong> {selectedBranch.businessPhone || 'N/A'}</p>
                <p><strong>Address:</strong> {selectedBranch.address || 'N/A'}</p>
              </div>
              <div className="space-y-3">
                <p><strong>User Limit:</strong> {selectedBranch.userLimit || 'No Limit'}</p>
                <p><strong>Holidays:</strong> {selectedBranch.weeklyHoliday?.join(', ') || 'Sunday'}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {confirmAction && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[10000]">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirm Action</h2>
            <p className="text-gray-700 mb-6">{confirmAction.message}</p>
            <div className="flex justify-center space-x-4">
              <button
                onClick={handleConfirmAction}
                disabled={submitting}
                className="px-6 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition disabled:bg-red-400"
              >
                {submitting ? 'Deleting...' : 'Confirm'}
              </button>
              <button
                onClick={handleCloseAlert}
                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-xl hover:bg-gray-300 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showSuccessAlert && <div className="fixed bottom-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50">{showSuccessAlert}</div>}
      {showAlert && <div className="fixed bottom-4 right-4 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg z-50">{showAlert}</div>}
    </div>
  );
};

export default Branch;


